import { useEffect, useState } from "react";
import RecommendedForm from "../../Interview/List/RecommendedForm";
import { useTranslation } from "react-i18next";
import { UserService } from "../../../services/UserService";
import { InterviewService } from "../../../services/InterviewService";
import { toast } from "react-toastify";
import { useGeneralContext } from "../../General/Context";
import { GeneralService } from "../../../services/GeneralService";

export default function Recommended({
  isOpenRecommendForm,
  closeForm,
  interviewId,
  companyId
}) {
  const [managers, setManagers] = useState([]);
  const [hrUsers, setHRUsers] = useState([]);
  const [otherManager, setOtherManager] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companyAbriviature, setCompanyAbriviature] = useState("");
  const [recommended, setRecommended] = useState({
    managerId: [],
    hrUsersId: [],
    otherManagerId: [],
    comment: ""
  });
  useEffect(() => {
    GeneralService.getAllAvailableCompanies().then((data) => {
      setCompanies(data);
    });
  }, []);

  useEffect(() => {
    setRecommended({
      ...recommended,
      interviewId: interviewId,
      companyId: companyId
    });
  }, [interviewId, companyId]);

  const companyManpping = {
    Bee: "bee-eng.pt",
    TeamIT: "team-it.pt",
    KCS: "kcsit.pt",
    Adentis: "adentis.pt",
    AGAP2: "agap2.pt",
    AGAP2NL: "agap2.nl",
    ATS4IT: "ats4it.com",
    RECODME: "recodme.es",
    Codewin: "sowin.pt",
    GMS: "global-market-solutions.de"
  };
  let { t } = useTranslation();

  const onChangeManagers = (event) => {
    if (recommended.managerId.includes(Number(event.target.value)) === false) {
      setRecommended({
        ...recommended,
        managerId: [...recommended.managerId, Number(event.target.value)]
      });
    } else {
      setRecommended({
        ...recommended,
        managerId: recommended.managerId.filter(
          (managerId) => managerId !== Number(event.target.value)
        )
      });
    }
  };

  const onChangeUserHR = (event) => {
    if (recommended.hrUsersId.includes(Number(event.target.value)) === false) {
      setRecommended({
        ...recommended,
        hrUsersId: [...recommended.hrUsersId, Number(event.target.value)]
      });
    } else {
      setRecommended({
        ...recommended,
        hrUsersId: recommended.hrUsersId.filter(
          (managerId) => managerId !== Number(event.target.value)
        )
      });
    }
  };
  //
  useEffect(() => {
    if (companyId && companies.length > 0) {
      UserService.getManagersToRecommend(companyId).then((result) => {
        let company = companies.find((x) => x.id == companyId);
        setCompanyAbriviature(company?.abreviature);
        let domain = companyManpping[company?.abreviature];
        setManagers(result.filter((x) => x.email.includes(domain)));
        setOtherManager(result.filter((x) => !x.email.includes(domain)));
      });
      UserService.getHRToRecommend(companyId).then((result) => {
        setHRUsers(result);
      });
    }
  }, [companyId, companies]);
  const onChangeOtherManager = (event) => {
    if (
      recommended.otherManagerId.includes(Number(event.target.value)) === false
    ) {
      setRecommended({
        ...recommended,
        otherManagerId: [
          ...recommended.otherManagerId,
          Number(event.target.value)
        ]
      });
    } else {
      setRecommended({
        ...recommended,
        otherManagerId: recommended.otherManagerId.filter(
          (managerId) => managerId !== Number(event.target.value)
        )
      });
    }
  };

  const onClickCheckAll = () => {
    if (recommended.managerId.length === managers.length) {
      setRecommended({
        ...recommended,
        managerId: []
      });
    } else {
      setRecommended({
        ...recommended,
        managerId: managers.map((manager) => manager.id)
      });
    }
  };

  const onClickCheckAllHR = () => {
    if (recommended.hrUsersId.length === hrUsers.length) {
      setRecommended({
        ...recommended,
        hrUsersId: []
      });
    } else {
      setRecommended({
        ...recommended,
        hrUsersId: hrUsers.map((hrUser) => hrUser.id)
      });
    }
  };

  const onClickCheckAllOtherManager = () => {
    if (recommended.otherManagerId.length === otherManager.length) {
      setRecommended({
        ...recommended,
        otherManagerId: []
      });
    } else {
      setRecommended({
        ...recommended,
        otherManagerId: otherManager.map((otherManager) => otherManager.id)
      });
    }
  };

  const onChangeComments = ({ target }) => {
    setRecommended({ ...recommended, comment: target.value });
  };

  const checkedRecommended = (managerId) => {
    return recommended.managerId.includes(managerId);
  };

  const checkedRecommendedHR_Users = (managerId) => {
    return recommended.hrUsersId.includes(managerId);
  };

  const checkedRecommendedOtherManager_Users = (managerId) => {
    return recommended.otherManagerId.includes(managerId);
  };

  const isValid = () => {
    let _error = {};
    if (
      recommended.managerId.length == 0 &&
      recommended.hrUsersId.length == 0 &&
      recommended.otherManagerId.length == 0
    )
      _error.managerId = t("Select at least one Manager or HR.");
    return Object.keys(_error).length === 0;
  };

  const recomendToManager = () => {
    if (!isValid()) {
      toast.error(t("Select at least one Manager or HR."));
      return;
    }

    InterviewService.recommendToManager(recommended).then((data) => {
      if (!data) {
        toast.success(t("Shared"));
      } else {
        toast.error(t("An unexpected error occurred"));
      }
    });
    closeForm();
  };
  return (
    <RecommendedForm
      isOpen={isOpenRecommendForm}
      closeForm={closeForm}
      managers={managers}
      hrUsers={hrUsers}
      otherManager={otherManager}
      modalTitle={t("Share with Manager")}
      submitText={t("Share")}
      commentIsDisabled={false}
      showCheckAllButton={true}
      checkedRecommended={checkedRecommended}
      checkedRecommendedHR_Users={checkedRecommendedHR_Users}
      checkedRecommendedOtherManager_Users={
        checkedRecommendedOtherManager_Users
      }
      onChangeManagers={onChangeManagers}
      onChangeUserHR={onChangeUserHR}
      onChangeOtherManager={onChangeOtherManager}
      onClickCheckAll={onClickCheckAll}
      onClickCheckAllHR={onClickCheckAllHR}
      onClickCheckAllOtherManager={onClickCheckAllOtherManager}
      onChangeComments={onChangeComments}
      submitButton={recomendToManager}
      comment={recommended.comment}
      checkBoxIsDisabled={() => false}
      companyAbriviature={companyAbriviature}
    />
  );
}
